var _style, _rect, _rect2, _rect3, _g, _text, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "18 20 184 62",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        @import\n        url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;700&amp;display=swap');\n        @keyframes pulse{0%,100%{opacity:0.75;}50%{opacity:1;}}\n        .car{animation:pulse 2.5s ease-in-out infinite; fill:#00C2FF;}\n        .d{fill:#0B1120;} .s{fill:#64748B;}\n        @media(prefers-color-scheme:dark){.d{fill:#F8FAFC;} .s{fill:#94A3B8;}}\n    ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 26,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#00C2FF",
    opacity: 0.85,
    transform: "rotate(15 32 34)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 25,
    width: 14,
    height: 56,
    rx: 3,
    fill: "#8B5CF6",
    opacity: 0.85
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 26,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#06B6D4",
    opacity: 0.85,
    transform: "rotate(-15 66 34)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "car",
    transform: "translate(20, 64) scale(0.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2,8 L 4,4 L 8,2 L 16,2 L 20,4 L 22,8 L 22,10 L 2,10 Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6,2 L 8,0 L 16,0 L 18,2",
    fill: "none",
    stroke: "#00C2FF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 11,
    r: 2,
    fill: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 11,
    r: 2,
    fill: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 11,
    r: 0.8,
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 11,
    r: 0.8,
    fill: "#00C2FF"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Plus Jakarta Sans',sans-serif",
    fontSize: 48,
    className: "d"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 58,
    y: 62,
    fontWeight: 700
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 74,
    y: 62,
    fontWeight: 700
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    x: 100,
    y: 62,
    fontWeight: 300,
    letterSpacing: -0.5
  }, "HAIL"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "'Plus Jakarta Sans',sans-serif",
    fontSize: 6.8,
    fontWeight: 700,
    className: "s"
  }, /*#__PURE__*/React.createElement("text", {
    x: 61,
    y: 74,
    letterSpacing: -0.2
  }, "TRUE"), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 73,
    r: 1.2,
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 84.5,
    y: 74,
    letterSpacing: -0.2
  }, "HAILING"), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 73,
    r: 1.2,
    fill: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 74,
    letterSpacing: -0.2
  }, "INFRASTRUCTURE"), /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 73,
    r: 1.2,
    fill: "#06B6D4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 181,
    y: 74,
    letterSpacing: -0.3
  }, "LAYER"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e99cf6ea40a3729f5e55c8b161e1dde8.svg";
export { ForwardRef as ReactComponent };